// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify .Toastify__toast-container .Toastify__toast {
  padding: 15px 20px;
  max-width: 400px;
  min-height: 80px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
}
.Toastify .Toastify__toast-container .Toastify__toast .Toastify__toast-body .toast-title,
.Toastify .Toastify__toast-container .Toastify__toast .Toastify__toast-body .toast-body {
  color: #ffffff;
  font-size: 12px;
}
.Toastify .Toastify__toast-container .Toastify__toast .Toastify__toast-body .toast-title {
  margin-bottom: 10px;
}
.Toastify .Toastify__toast-container .Toastify__toast .delete-icon {
  position: absolute;
  top: 14px;
  right: 15px;
  color: #ffffff;
  opacity: 1;
  font-size: 20px;
  font-weight: normal;
  line-height: 100%;
}
.Toastify .Toastify__toast-container .Toastify__toast .Toastify__progress-bar {
  background: rgba(255, 255, 255, 0.5);
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default {
  background-color: #0e68e8;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.care-at-home {
  background-color: #f37021;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.guide {
  background-color: #d51566;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.self-directing {
  background-color: #326787;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.vpc {
  background-color: #6916ba;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.vpc-shared {
  background-color: #e9dcf5;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.vpc-shared .toast-title,
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.vpc-shared .toast-body,
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--default.vpc-shared .delete-icon {
  color: #6916ba;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--error {
  background-color: #a53120;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--success {
  background-color: #154c30;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--success .toast-title,
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--success .toast-body,
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--success .delete-icon {
  color: #ffffff;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--warning {
  background-color: #fec25f;
}
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--warning .toast-title,
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--warning .toast-body,
.Toastify .Toastify__toast-container .Toastify__toast.Toastify__toast--warning .delete-icon {
  color: #444444;
}
`, "",{"version":3,"sources":["webpack://./../styleguide/src/components/Toast/main.less"],"names":[],"mappings":"AAEA;EAGM,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;AAHN;AAHA;;EAWU,cAAA;EACA,eAAA;AAJV;AARA;EAeU,mBAAA;AAJV;AAXA;EAmBQ,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AALR;AArBA;EA6BQ,oCAAA;AALR;AAQM;EACE,yBAAA;AANR;AASM;EACE,yBAAA;AAPR;AASM;EACE,yBAAA;AAPR;AASM;EACE,yBAAA;AAPR;AASM;EACE,yBAAA;AAPR;AASM;EACE,yBAAA;AAPR;AAMM;;;EAKI,cAAA;AANV;AASM;EACE,yBAAA;AAPR;AASM;EACE,yBAAA;AAPR;AAMM;;;EAMI,cAAA;AAPV;AAUM;EACE,yBAAA;AARR;AAOM;;;EAMI,cAAA;AARV","sourcesContent":["@import '~styleguide/src/styles/variables.less';\n\n.Toastify {\n  .Toastify__toast-container {\n    .Toastify__toast {\n      padding: 15px 20px;\n      max-width: 400px;\n      min-height: 80px;\n      box-shadow: @tooltip-shadow;\n\n      .Toastify__toast-body {\n        .toast-title,\n        .toast-body {\n          color: @white;\n          font-size: 12px;\n        }\n        .toast-title {\n          margin-bottom: 10px;\n        }\n      }\n      .delete-icon {\n        position: absolute;\n        top: 14px;\n        right: 15px;\n        color: @white;\n        opacity: 1;\n        font-size: 20px;\n        font-weight: normal;\n        line-height: 100%;\n      }\n      .Toastify__progress-bar {\n        background: fade(@white, 50%);\n      }\n\n      &.Toastify__toast--default {\n        background-color: @tertiaryBlue;\n      }\n\n      &.Toastify__toast--default.care-at-home {\n        background-color: @cah-toast-background;\n      }\n      &.Toastify__toast--default.guide {\n        background-color: @guide-toast-background;\n      }\n      &.Toastify__toast--default.self-directing {\n        background-color: @self-directing-toast-background;\n      }\n      &.Toastify__toast--default.vpc {\n        background-color: @vpc-toast-background;\n      }\n      &.Toastify__toast--default.vpc-shared {\n        background-color: @vpc-shared-toast-background;\n        .toast-title,\n        .toast-body,\n        .delete-icon {\n          color: @vpc-shared-toast-color;\n        }\n      }\n      &.Toastify__toast--error {\n        background-color: @textRed2;\n      }\n      &.Toastify__toast--success {\n        background-color: @textGreen;\n\n        .toast-title,\n        .toast-body,\n        .delete-icon {\n          color: @white;\n        }\n      }\n      &.Toastify__toast--warning {\n        background-color: @gold;\n\n        .toast-title,\n        .toast-body,\n        .delete-icon {\n          color: @textBlack;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
